export default function Video(props) {
  return (
    <video {...props} src={props?.src + '?format=originalOFGHLERTH'} preload="none" height="auto" autoPlay loop muted />
  );
}
